import actions from '../../../../redux/actions/ui/dataImport/strategies/trackingStrategy.js'
import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default function TrackingStrategy(props) {
  return (
    <BaseStrategy
      {...props}
      actions={actions}
      EditForm={EditForm}
      ReconcileForm={ReconcileForm}
    />
  )
}

TrackingStrategy.title = actions.title
const option = {
  value: 'create_tracking_numbers',
  display: 'Create Tracking Numbers',
  category: 'orders',
  Component: TrackingStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
TrackingStrategy.option = option
